import React, { useState } from "react";
import { Button, ButtonToolbar, Modal } from "rsuite";
import ModalFooter from "rsuite/esm/Modal/ModalFooter";
import { SubStateVM } from "../../../Models/ViewModels";
import { BootstrapIcon } from "../../../SharedComponents/BootstrapIcon";
import { AddEditDeleteSubState } from "./AddEditDeleteSubstate";

type attributes = {
  action: string;
  data: SubStateVM;
  onAction: any;
  cachedData: any;
};


export const SubStateModal = (props: attributes) => {
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const handleOpen = (value: any) => {
    setSize(value);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const onAddSubstate = (substateDetail: SubStateVM) => {
    handleClose();
    props.onAction(substateDetail);
  };
  const onEditSubstate = (substateDetail: SubStateVM) => {
    handleClose();
    props.onAction(substateDetail);
  };
  const onDeleteSubstate = (substateDetail: SubStateVM) => {
    handleClose();
    props.onAction(substateDetail);
  };

  if (props.action === "edit") {
    return (
      <div className="modal-container">
        <i
          className="bi bi-pencil-fill text-warning"
          onClick={() => handleOpen("xs")}
        ></i>
        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteSubState
            title="Edit SubState"
            type={props.action}
            data={props.data}
            cachedData={props.cachedData}
            onAction={onEditSubstate}
          />
        </Modal>
      </div>
    );
  } else if (props.action === "add") {
    return (
      <div className="modal-container">
        <ButtonToolbar>
          <Button
            appearance="primary"
            color="green"
            size="md"
            onClick={() => handleOpen("xs")}
          >
            <BootstrapIcon
              bootStrapIconName="plus"
              size={15}
              cssClasses="me-1"
            />
            Add
          </Button>
        </ButtonToolbar>

        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteSubState
            type="add"
            title="Add New SubState"
            data={props.data}
            cachedData={props.cachedData}
            onAction={onAddSubstate}
          />
          <ModalFooter></ModalFooter>
        </Modal>
      </div>
    );
  } else {
    return (
      <div className="modal-container">
        <ButtonToolbar>
          <i
            className="bi bi-trash3-fill text-danger"
            onClick={() => handleOpen("xs")}
          ></i>
        </ButtonToolbar>
        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteSubState
            title="Delete SubState"
            type={props.action}
            data={props.data}
            cachedData={props.cachedData}
            onAction={onDeleteSubstate}
          />
        </Modal>
      </div>
    );
  }
};
